import { initialSetupApplicationStateName } from 'modules/initialSetup';
import { INITIAL_SETUP_INTRODUCTION_BUTTON_CLICKED } from 'modules/initialSetup/initialSetupSegmentEvents';
import './introductionStep.scss';
export class IntroductionStepController {
    static $inject = ['SegmentService', '$state'];
    constructor(SegmentService, $state) {
        'ngInject';
        this.SegmentService = SegmentService;
        this.$state = $state;
    }
    async goToMembersAddition() {
        this.SegmentService.createOrganizationTrack(INITIAL_SETUP_INTRODUCTION_BUTTON_CLICKED);
        this.$state.go(initialSetupApplicationStateName);
    }
}
IntroductionStepController.$inject = ['SegmentService', '$state'];
